import { useState } from 'react';
import { Icon } from './Icon';
import { Modal } from './Modal';
import { usePwaInstall } from '../lib/pwa';

export function InstallPwaButton({ className = '' }: { className?: string }) {
  const { available, installed, isIos, install } = usePwaInstall();
  const [helpOpen, setHelpOpen] = useState(false);

  if (!available || installed) return null;

  const handleClick = async () => {
    if (isIos) {
      setHelpOpen(true);
      return;
    }
    const accepted = await install();
    if (!accepted) setHelpOpen(true);
  };

  return (
    <>
      <button
        type="button"
        className={`button button--secondary pwa-install ${className}`.trim()}
        onClick={() => void handleClick()}
      >
        <Icon name="download" size={18} />
        Instalar Reino de Tableros
      </button>

      <Modal
        open={helpOpen}
        onClose={() => setHelpOpen(false)}
        title="Instalar en iPhone o iPad"
        subtitle="Añade el juego a la pantalla de inicio y ábrelo como una app."
      >
        <div className="pwa-help">
          <ol>
            <li>Abre esta página en <strong>Safari</strong>.</li>
            <li>Toca el botón <strong>Compartir</strong> de la barra inferior.</li>
            <li>Elige <strong>Añadir a pantalla de inicio</strong>.</li>
            <li>Confirma con <strong>Añadir</strong>.</li>
          </ol>
          <p>Si ya está instalada, este botón desaparecerá automáticamente.</p>
        </div>
      </Modal>
    </>
  );
}
